import { IMockProps, Mocks, MockServiceType } from '../../Core';
import { ENDPOINT_API_PATH } from '../../Apis/GetCmsDeliveryApi';
import { CobrandedCardsMocksDef } from '../../Mocks';
import { CmsDeliveryTypes as Internals } from '../../Types/internals';

const generateSuccess = (params: Internals.CmsDeliveryRequest): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: `${ENDPOINT_API_PATH}/${params.contentId}`,
      params: { format: 'simple' },
    },
    configResponse: {
      status: 200,
      data: CobrandedCardsMocksDef.COBRANDED_CARDS_RAW_RESULT,
    },
  };
};

const mocksSuccess: IMockProps[] = [
  generateSuccess({
    contentId: 'content-id',
  }),
];

export const mocksService: MockServiceType[] = mocksSuccess.map((request) => ({
  label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
  value: request.configRequest.params,
}));

Mocks.getInstance().addAll(mocksSuccess);
